import { AppDispatch } from '../../../store'
import Client from '../Client/Client'
import {
  IAbsenceRequest,
} from '../Client/IAbsenceRequest'
import { IAbsenceRequestStatistics } from '../Client/IAbsenceRequestStatistics'

import {
  APPROVE_ABSENCE_REQUEST_FAILURE,
  APPROVE_ABSENCE_REQUEST_REQUEST,
  APPROVE_ABSENCE_REQUEST_SUCCESS,
  CREATE_ABSENCE_REQUEST_FAILURE,
  CREATE_ABSENCE_REQUEST_REQUEST,
  CREATE_ABSENCE_REQUEST_SUCCESS,
  DECLINE_ABSENCE_REQUEST_REQUEST,
  DECLINE_ABSENCE_REQUEST_SUCCESS,
  DELETE_ABSENCE_REQUEST_REQUEST,
  DELETE_ABSENCE_REQUEST_SUCCESS,
  GET_ABSENCE_REQUESTS_REQUEST,
  GET_ABSENCE_REQUESTS_SUCCESS,
  GET_ABSENCE_STATISTICS_REQUEST,
  GET_ABSENCE_STATISTICS_SUCCESS,
  UPDATE_ABSENCE_REQUEST_REQUEST,
  UPDATE_ABSENCE_REQUEST_SUCCESS,
} from './ActionTypes'
import IState from './IState'

export const getAbsenceRequests = (activeUser: {
  uuid: string
  firstName: string
  lastName: string
} | undefined) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: GET_ABSENCE_REQUESTS_REQUEST,
    })

    return Client.getAbsenceRequests(activeUser).then(
      (absenceRequests: IAbsenceRequest[]) => {
        dispatch(getAbsenceRequestsSuccess(absenceRequests))
      },
    )
  }
}

export const getAbsenceRequestsSuccess = (
  absenceRequests: IAbsenceRequest[],
) => {
  return {
    type: GET_ABSENCE_REQUESTS_SUCCESS,
    payload: {
      absenceRequests,
    },
  }
}

export const createAbsenceRequest = (absenceRequest: IAbsenceRequest) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CREATE_ABSENCE_REQUEST_REQUEST,
    })

    return Client.createAbsenceRequest(absenceRequest)
      .then((newAbsenceRequest: IAbsenceRequest) => {
        dispatch(createAbsenceRequestSuccess(newAbsenceRequest))
        return newAbsenceRequest
      })
      .catch(error => {
        dispatch(createAbsenceRequestFailure(error.response.data.message))
        throw error
      })
  }
}

export const createAbsenceRequestSuccess = (
  absenceRequest: IAbsenceRequest,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CREATE_ABSENCE_REQUEST_SUCCESS,
      payload: {
        absenceRequest,
      },
    })
  }
}

export const createAbsenceRequestFailure = (errorMessage: string) => {
  return {
    type: CREATE_ABSENCE_REQUEST_FAILURE,
    payload: { error: errorMessage },
  }
}

export const deleteAbsenceRequest = (absenceRequest: IAbsenceRequest) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DELETE_ABSENCE_REQUEST_REQUEST,
    })

    return Client.deleteAbsenceRequest(absenceRequest).then(() =>
      dispatch(deleteAbsenceRequestSuccess(absenceRequest)),
    )
  }
}

export const deleteAbsenceRequestSuccess = (
  absenceRequest: IAbsenceRequest,
) => {
  return {
    type: DELETE_ABSENCE_REQUEST_SUCCESS,
    payload: {
      absenceRequest,
    },
  }
}

export const updateAbsenceRequest = (absenceRequest: IAbsenceRequest) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_ABSENCE_REQUEST_REQUEST,
    })

    return Client.updateAbsenceRequest(absenceRequest).then(
      (updatedAbsenceRequest: IAbsenceRequest) => {
        dispatch(updateAbsenceRequestSuccess(updatedAbsenceRequest))
      },
    )
  }
}

export const updateAbsenceRequestSuccess = (
  absenceRequest: IAbsenceRequest,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: UPDATE_ABSENCE_REQUEST_SUCCESS,
      payload: {
        absenceRequest,
      },
    })
  }
}

export const approveAbsenceRequest = (absenceRequest: IAbsenceRequest) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: APPROVE_ABSENCE_REQUEST_REQUEST,
    })

    return Client.approveAbsenceRequest(absenceRequest)
        .then((approvedAbsenceRequest: IAbsenceRequest) => {
          dispatch(approveAbsenceRequestSuccess(approvedAbsenceRequest))
        })
        .catch(error => {
          dispatch(approveAbsenceRequestFailure(error.response.data.message))
          throw error
        })
  }
}

export const approveAbsenceRequestSuccess = (
  absenceRequest: IAbsenceRequest,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: APPROVE_ABSENCE_REQUEST_SUCCESS,
      payload: {
        absenceRequest,
      },
    })
  }
}

export const approveAbsenceRequestFailure = (errorMessage: string) => {
  return {
    type: APPROVE_ABSENCE_REQUEST_FAILURE,
    payload: { error: errorMessage },
  }
}

export const declineAbsenceRequest = (absenceRequest: IAbsenceRequest) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DECLINE_ABSENCE_REQUEST_REQUEST,
    })

    return Client.declineAbsenceRequest(absenceRequest).then(
      (declinedAbsenceRequest: IAbsenceRequest) => {
        dispatch(declineAbsenceRequestSuccess(declinedAbsenceRequest))
      },
    )
  }
}

export const declineAbsenceRequestSuccess = (
  absenceRequest: IAbsenceRequest,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: DECLINE_ABSENCE_REQUEST_SUCCESS,
      payload: {
        absenceRequest,
      },
    })
  }
}

export const getAbsenceStatistics = () => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: GET_ABSENCE_STATISTICS_REQUEST,
    })

    return Client.getAbsenceStatistics().then(
      (absenceStatistics: IAbsenceRequestStatistics[]) => {
        dispatch(getAbsenceStatisticsSuccess(absenceStatistics))
      },
    )
  }
}

export const getAbsenceStatisticsSuccess = (
  statistics: IAbsenceRequestStatistics[],
) => {
  return {
    type: GET_ABSENCE_STATISTICS_SUCCESS,
    payload: {
      statistics,
    },
  }
}
